import { render, staticRenderFns } from "./QuizResultCard.vue?vue&type=template&id=14f6f33f&scoped=true"
import script from "./QuizResultCard.vue?vue&type=script&lang=js"
export * from "./QuizResultCard.vue?vue&type=script&lang=js"
import style0 from "./QuizResultCard.vue?vue&type=style&index=0&id=14f6f33f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f6f33f",
  null
  
)

export default component.exports